import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteEventAccountMutationVariables = Types.Exact<{
  event_account_id: Types.Scalars['ID'];
}>;


export type DeleteEventAccountMutation = { __typename?: 'Mutation', deleteEventAccount: string };


export const DeleteEventAccountDocument = gql`
    mutation deleteEventAccount($event_account_id: ID!) {
  deleteEventAccount(event_account_id: $event_account_id)
}
    `;
export type DeleteEventAccountMutationFn = Apollo.MutationFunction<DeleteEventAccountMutation, DeleteEventAccountMutationVariables>;

/**
 * __useDeleteEventAccountMutation__
 *
 * To run a mutation, you first call `useDeleteEventAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventAccountMutation, { data, loading, error }] = useDeleteEventAccountMutation({
 *   variables: {
 *      event_account_id: // value for 'event_account_id'
 *   },
 * });
 */
export function useDeleteEventAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventAccountMutation, DeleteEventAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventAccountMutation, DeleteEventAccountMutationVariables>(DeleteEventAccountDocument, options);
      }
export type DeleteEventAccountMutationHookResult = ReturnType<typeof useDeleteEventAccountMutation>;
export type DeleteEventAccountMutationResult = Apollo.MutationResult<DeleteEventAccountMutation>;
export type DeleteEventAccountMutationOptions = Apollo.BaseMutationOptions<DeleteEventAccountMutation, DeleteEventAccountMutationVariables>;